import React, { useEffect } from 'react'
import { clearToken } from '../../services/util'
import GenericError from './GenericError'

const ErrorTokenExpiredPage = () => {
  // silent logout for user on 405
  // silent means no redirect to login page
  // This is to allow the user to go to login page on refresh because the page does not have any actions
  const logout = () => {
    clearToken()
    window.localStorage.clear()
  }

  useEffect(() => {
    setTimeout(() => {
      logout()
    }, 1000)
  }, [])

  return <GenericError />
}

export default ErrorTokenExpiredPage
